import { Permission } from "~/graphql/client"

export const DESIGNER_ALLOWED_PERMISSIONS = [
  Permission.proposal_creation,
  Permission.admin,
  Permission.vision_proposal_admin,
  Permission.vision_admin,
  Permission.vision_service_bureau_admin,
  Permission.vision_service_bureau_user,
  Permission.vision_designer_user,
  Permission.mentorship_assignment,
  Permission.org_mentor_access,
  Permission.enterprise_admin,
  Permission.enterprise_admin_pro,
  Permission.enterprise_super_admin,
]
